import { render } from "./QuestionYesNoScene.vue?vue&type=template&id=0be9bee2&scoped=true"
import script from "./QuestionYesNoScene.vue?vue&type=script&lang=js"
export * from "./QuestionYesNoScene.vue?vue&type=script&lang=js"

import "./QuestionYesNoScene.vue?vue&type=style&index=0&id=0be9bee2&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be9bee2"]])

export default __exports__